/** Return the insertion boundary in the destination's visible card order. */
export function componentDropPosition(target: HTMLElement, x: number, y: number, rail: boolean) {
  const nodes = Array.from(target.querySelectorAll<HTMLElement>(rail ? "[data-rail-component-type]" : ".workbench-cell"));
  const cards = nodes.filter(node => { const r = node.getBoundingClientRect(); return r.width > 0 && r.height > 0; });
  let index = cards.findIndex(node => { const r = node.getBoundingClientRect(); return rail ? y < r.top + r.height / 2 : y < r.top || (y <= r.bottom && x < r.left + r.width / 2); });
  if (index < 0) index = cards.length;
  const rect = target.getBoundingClientRect();
  const boundary = cards[index]?.getBoundingClientRect().top ?? cards.at(-1)?.getBoundingClientRect().bottom ?? rect.top + 16;
  target.style.setProperty("--component-drop-y", `${boundary - rect.top + target.scrollTop}px`);
  return index;
}
